import { Button, Modal } from '@ksyos/design-system';
import type { IAdminProcess } from '@common/interfaces';
import type {
    IServiceActivity,
    IServiceWorkflowStep,
    IServiceWorkflowStepActivity,
    IServiceWorkflowTransition,
} from '@frontend/components/pages/services/workflowGraph/WorkflowGraph';
import { WorkflowGraph } from '@frontend/components/pages/services/workflowGraph/WorkflowGraph';

type ProcessWorkflowModalProps = {
    isLoading: boolean;
    isOpen: boolean;
    onClose: () => void;
    onReloadProcess: () => void;
    process: IAdminProcess;
    serviceActivities: IServiceActivity[];
    serviceWorkflowStepActivities: IServiceWorkflowStepActivity[];
    serviceWorkflowSteps: IServiceWorkflowStep[];
    serviceWorkflowTransitions: IServiceWorkflowTransition[];
};

export function ProcessWorkflowModal({
    isOpen,
    serviceWorkflowSteps,
    serviceWorkflowStepActivities,
    serviceWorkflowTransitions,
    serviceActivities,
    onClose,
    onReloadProcess,
    process,
    isLoading,
}: ProcessWorkflowModalProps) {
    return (
        <Modal
            closeOnEsc={true}
            closeOnOverlayClick={true}
            isOpen={isOpen}
            onClose={onClose}
            size="fullscreen"
        >
            <Modal.Header>Proces Workflow</Modal.Header>
            <Modal.CloseButton />
            <Modal.Body>
                <WorkflowGraph
                    process={process}
                    serviceActivities={serviceActivities}
                    serviceWorkflowStepActivities={serviceWorkflowStepActivities}
                    serviceWorkflowSteps={serviceWorkflowSteps}
                    serviceWorkflowTransitions={serviceWorkflowTransitions}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button
                    iconRight="refresh"
                    isDisabled={isLoading}
                    onClick={() => onReloadProcess()}
                    variant="outline"
                >
                    Refresh
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
